// src/directives/showpass.js

const showpass = {
  mounted(el) {
    const wrapper = document.createElement("div");
    wrapper.style.position = "relative";
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);

    const icon = document.createElement("img");
    icon.setAttribute("src", "/img/eye-outline.svg");
    icon.style.position = "absolute";
    icon.style.right = "10px";
    icon.style.top = "50%";
    icon.style.transform = "translateY(-50%)";
    icon.style.cursor = "pointer";
    icon.style.width = "20px";
    icon.style.height = "20px";

    el.parentNode.appendChild(icon);

    let isPasswordVisible = false;

    icon.addEventListener("click", () => {
      isPasswordVisible = !isPasswordVisible;
      if (isPasswordVisible) {
        el.setAttribute("type", "text");
        icon.setAttribute("src", "/img/eye-remove-outline.svg");
      } else {
        el.setAttribute("type", "password");
        icon.setAttribute("src", "/img/eye-outline.svg");
      }
    });
  }
};

export default showpass;
